// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_WorkOrderStepUpdateStatusResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/orders/work_order_step_update_status/{step_id}
 *
 * Returns the step id and its new status.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_WorkOrderStepUpdateStatusResponseDados {
step_id: number
status: string
}

export type Orders_WorkOrderStepUpdateStatusResponse = ApiResponse<Orders_WorkOrderStepUpdateStatusResponseDados>;

registerResponseContract('Orders_WorkOrderStepUpdateStatusResponse', {
  step_id: { type: 'number',  required: true },
  status:  { type: 'string',  required: true },
})
